import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';

import { KYMW1002Component } from './kymw1002.component';

import { KYMW0C00Module } from '../../../commons/kymw0c/kymw0c00/kymw0c00.module';
import { KYMW1000Module } from '../kymw1000/kymw1000.module';
import { KYMW1100Module } from '../../kymw11/kymw1100/kymw1100.module';
import { KYMW1200Module } from '../../kymw12/kymw1200/kymw1200.module';
import { KYMW1201Module } from '../../kymw12/kymw1201/kymw1201.module';
import { KYMW1300Module } from '../../kymw13/kymw1300/kymw1300.module';
import { KYMW1400Module } from '../../kymw14/kymw1400/kymw1400.module';
import { KYMW1500Module } from '../../kymw15/kymw1500/kymw1500.module';
import { KYMW1600Module } from '../../kymw16/kymw1600/kymw1600.module';
import { KYMW1700Module } from '../../kymw17/kymw1700/kymw1700.module';
import { KYMW1800Module } from '../../kymw18/kymw1800/kymw1800.module';
import { KYMW2000Module } from '../../kymw20/kymw2000/kymw2000.module';
import { KYMW2100Module } from '../../kymw21/kymw2100/kymw2100.module';
import { KYMW2200Module } from '../../kymw22/kymw2200/kymw2200.module';
import { KYMW2300Module } from '../../kymw23/kymw2300/kymw2300.module';
import { KYMW2400Module } from '../../kymw24/kymw2400/kymw2400.module';
import { KYMW2500Module } from '../../kymw25/kymw2500/kymw2500.module';
import { KYMW2600Module } from '../../kymw26/kymw2600/kymw2600.module';
import { KYMW2700Module } from '../../kymw27/kymw2700/kymw2700.module';
import { KYMW2800Module } from '../../kymw28/kymw2800/kymw2800.module';
import { KYMW2900Module } from '../../kymw29/kymw2900/kymw2900.module';
import { KYMW4000Module } from '../../kymw40/kymw4000/kymw4000.module';
import { KYMW4100Module } from '../../kymw41/kymw4100/kymw4100.module';
import { KYMW4200Module } from '../../kymw42/kymw4200/kymw4200.module';
import { KYMW4300Module } from '../../kymw43/kymw4300/kymw4300.module';
import { KYMW4400Module } from '../../kymw44/kymw4400/kymw4400.module';
import { KYMW4500Module } from '../../kymw45/kymw4500/kymw4500.module';
import { KYMW4600Module } from '../../kymw46/kymw4600/kymw4600.module';
import { KYMW4700Module } from '../../kymw47/kymw4700/kymw4700.module';
import { KYMW4800Module } from '../../kymw48/kymw4800/kymw4800.module';
import { KYMW4802Module } from '../../kymw48/kymw4802/kymw4802.module';
import { KYMW5300Module } from '../../kymw53/kymw5300/kymw5300.module';
import { KYMW5400Module } from '../../kymw54/kymw5400/kymw5400.module';
import { KYMW5500Module } from '../../kymw55/kymw5500/kymw5500.module';
import { KYMW5900Module } from '../../kymw59/kymw5900/kymw5900.module';
import { KYMW6000Module } from '../../kymw60/kymw6000/kymw6000.module';
import { KYMW6001Module } from '../../kymw60/kymw6001/kymw6001.module';
import { KYMW6100Module } from '../../kymw61/kymw6100/kymw6100.module';
import { KYMW6500Module } from '../../kymw65/kymw6500/kymw6500.module';
import { KYMW6600Module } from '../../kymw66/kymw6600/kymw6600.module';
import { KYMW6700Module } from '../../kymw67/kymw6700/kymw6700.module';
import { KYMW6800Module } from '../../kymw68/kymw6800/kymw6800.module';
import { KYMW6900Module } from '../../kymw69/kymw6900/kymw6900.module';
import { KYMW6901Module } from '../../kymw69/kymw6901/kymw6901.module';
import { KYMW7000Module } from '../../kymw70/kymw7000/kymw7000.module';
import { KYMW7001Module } from '../../kymw70/kymw7001/kymw7001.module';
import { KYMW7004Module } from '../../kymw70/kymw7004/kymw7004.module';
import { KYMW7005Module } from '../../kymw70/kymw7005/kymw7005.module';
import { KYMW7006Module } from '../../kymw70/kymw7006/kymw7006.module';
import { KYMW7007Module } from '../../kymw70/kymw7007/kymw7007.module';
import { KYMW7100Module } from '../../kymw71/kwmy7100/kymw7100.module';
import { KYMW7200Module } from '../../kymw72/kymw7200/kymw7200.module';
import { KYMW7300Module } from '../../kymw73/kymw7300/kymw7300.module';
import { KYMW7301Module } from '../../kymw73/kymw7301/kymw7301.module';
import { KYMW7400Module } from '../../kymw74/kymw7400/kymw7400.module';
import { KYMW7500Module } from '../../kymw75/kymw7500/kymw7500.module';
import { KYMW9000Module } from '../../kymw90/kymw9000/kymw9000.module';
import { KYMW9003Module } from '../../kymw90/kymw9003/kymw9003.module';
import { KYMW9006Module } from '../../kymw90/kymw9006/kymw9006.module';
import { KYMW9009Module } from '../../kymw90/kymw9009/kymw9009.module';
import { KYMW9011Module } from '../../kymw90/kymw9011/kymw9011.module';
import { KYMW9100Module } from '../../kymw91/kymw9100/kymw9100.module';
import { KYMW9200Module } from '../../kymw92/kymw9200/kymw9200.module';
import { KYMW9300Module } from '../../kymw93/kymw9300/kymw9300.module';
import { KYMW9400Module } from '../../kymw94/kymw9400/kymw9400.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetInfomationService } from './api-services/get-infomation.service';
import { GetCommonSettingService } from './api-services/get-common-setting.service';
import { GetDashboardMessageService } from './api-services/get-dashboard-message.service';
import { GetDashboardLockInfoService } from './api-services/get-dashboard-lock-info.service';
import { ReleaseImageLockService } from './api-services/release-image-lock.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DownloadResultLogService } from './api-services/download-resultlog.service';
import { PlessDownloadService } from 'src/app/shared/http/pless-download.service';
import { GetResultLogPathService } from './api-services/get-result-log-path.service';
import { GetUserSupplierCodeListService } from './api-services/get-user-supplier-code-list.service';
import { UpdateAssociatedCompanyIdService } from './api-services/update-associated-company-id.service';

/**
 * メインメニュー画面　モジュール設定クラス
 *
 * 提供時：
 * app/main/main.module.ts
 *
 * @export KYMW1002Module
 * @class KYMW1002Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FontAwesomeModule,
    NgbTooltipModule,
    WjGridModule,
    WjGridFilterModule,

    KYMW0C00Module,
    KYMW1000Module,
    KYMW1100Module,
    KYMW1200Module,
    KYMW1201Module,
    KYMW1300Module,
    KYMW1400Module,
    KYMW1500Module,
    KYMW1600Module,
    KYMW1700Module,
    KYMW1800Module,
    KYMW2000Module,
    KYMW2100Module,
    KYMW2200Module,
    KYMW2300Module,
    KYMW2400Module,
    KYMW2500Module,
    KYMW2600Module,
    KYMW2700Module,
    KYMW2800Module,
    KYMW2900Module,
    KYMW4000Module,
    KYMW4100Module,
    KYMW4200Module,
    KYMW4300Module,
    KYMW4400Module,
    KYMW4500Module,
    KYMW4600Module,
    KYMW4700Module,
    KYMW4800Module,
    KYMW4802Module,
    KYMW5300Module,
    KYMW5400Module,
    KYMW5500Module,
    KYMW5900Module,
    KYMW6000Module,
    KYMW6001Module,
    KYMW6100Module,
    KYMW6500Module,
    KYMW6600Module,
    KYMW6700Module,
    KYMW6800Module,
    KYMW6900Module,
    KYMW6901Module,
    KYMW7000Module,
    KYMW7001Module,
    KYMW7004Module,
    KYMW7005Module,
    KYMW7006Module,
    KYMW7007Module,
    KYMW7100Module,
    KYMW7200Module,
    KYMW7300Module,
    KYMW7301Module,
    KYMW7400Module,
    KYMW7500Module,
    KYMW9000Module,
    KYMW9003Module,
    KYMW9006Module,
    KYMW9009Module,
    KYMW9011Module,
    KYMW9100Module,
    KYMW9200Module,
    KYMW9300Module,
    KYMW9400Module,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1002Component,
  ],
  providers: [
    KYMW1002Component,
    GetInfomationService,
    GetCommonSettingService,
    GetDashboardMessageService,
    GetDashboardLockInfoService,
    ReleaseImageLockService,
    DownloadResultLogService,
    PlessDownloadService,
    GetResultLogPathService,
    GetUserSupplierCodeListService,
    UpdateAssociatedCompanyIdService,
  ],
})

export class KYMW1002Module { }
